import DSFooter, {
  NotFdicInsuredDisclosure,
  BottomCopyrightLine,
  MmfDisclosure,
} from './src'

export default DSFooter

export { NotFdicInsuredDisclosure, BottomCopyrightLine, MmfDisclosure }
